import { Card } from "react-bootstrap"

interface IndicatorCardProps {
  title: string
  value: string | number
  previousValue?: number
  format?: "number" | "money" | "percent"
  icon?: string
  color?: string
}

function formatValue(value: string | number, format?: string): string {
  if (typeof value === "string") return value
  switch (format) {
    case "money":
      return value.toLocaleString("en-US", { style: "currency", currency: "DOP", minimumFractionDigits: 0, maximumFractionDigits: 0 })
    case "percent":
      return `${value}%`
    case "number":
    default:
      return value.toLocaleString()
  }
}

function getTrend(current: string | number, previous?: number) {
  if (previous === undefined || previous === 0 || typeof current === "string") return null
  const change = ((Number(current) - previous) / previous) * 100
  return { change: Math.round(change * 10) / 10, isUp: change >= 0 }
}

export default function IndicatorCard({ title, value, previousValue, format, icon, color }: IndicatorCardProps) {
  const trend = getTrend(value, previousValue)

  return (
    <Card className="shadow-sm h-100 border-0">
      <Card.Body className="d-flex align-items-center">
        {icon && (
          <div
            className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
            style={{ width: 48, height: 48, backgroundColor: color || "#e8f4f8" }}
          >
            <i className={`fas ${icon}`} style={{ color: color ? "#fff" : "#0d6efd", fontSize: 18 }} />
          </div>
        )}
        <div className="flex-grow-1">
          <div className="text-muted small mb-1">{title}</div>
          <div className="fw-bold fs-4">{formatValue(value, format)}</div>
          {trend && (
            <div className={`small ${trend.isUp ? "text-success" : "text-danger"}`}>
              <i className={`fas fa-arrow-${trend.isUp ? "up" : "down"} me-1`} />
              {Math.abs(trend.change)}%
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  )
}
